import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import useEligibleServicesLine from './hooks/useEligibleServicesLine';
import EligibleServicesModal from './EligibleServicesModal';

interface Props {
  policyId?: number | string;
  accountName?: string;
  accountType?: string;
}

const EligibleServicesLine: React.FC<Props> = ({ policyId, accountName, accountType }) => {
  const { displayLabel, categories, extraCount, total, isLoading, handleOpenModal } =
    useEligibleServicesLine(policyId);

  if (isLoading || total === 0) {
    return null;
  }

  return (
    <>
      <Box
        data-testid="eligible-services-line_wrapper"
        direction="row"
        align="center"
        gap="xxsmall"
        margin={{ left: 'spacing4', top: 'spacing12'}}
      >
        <Text
          data-testid="eligible-services-line_text"
          size="small"
          weight={500}
          color="textSecondary"
        >
          {displayLabel}
        </Text>
        {extraCount > 0 && (
          <Text
            data-testid="eligible-services-line_extra-count"
            size="small"
            weight={500}
            color="textAccent"
            style={{ cursor: 'pointer' }}
            onClick={handleOpenModal}
          >
            {`+${extraCount}`}
          </Text>
        )}
      </Box>
        <EligibleServicesModal
          categories={categories}
          accountName={accountName}
          accountType={accountType}
          policyId={policyId}
        />
    </>
  );
};

export default EligibleServicesLine;
